import $http from "../../axios";
import { Notification } from "element-ui";

function notifyError(error, defaultMessage) {
    let message = defaultMessage;

    if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
    }

    Notification.error({
        title: "Error!",
        message,
        type: "error",
        duration: 3000,
        customClass: "notification-box"
    });
}

export async function fetchProjectBalance({ commit }, params) {
    commit("setLoading", true);
    await $http
        .get("/api/balance-de-proyectos", { params })
        .then(response => {
            commit("setProjectBalanceList", response.data.data);
        })
        .catch(error => {
            commit("setProjectBalanceList", []);
            notifyError(error, "Error al consultar el balance de proyectos");
        });
    commit("setLoading", false);
}



// WEBPACK FOOTER //
// ./src/modules/project-balance/actions.js